import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TopBar from './TopBar';
import Navbar from './Navbar';
import Hero from './Hero';
import ImpactSection from './ImpactSection';
import WhatWeDoSection from './WhatWeDoSection';
import EcosystemSection from './EcosystemSection';
import TailoredSolutionsSection from './TailoredSolutionsSection';
import TechnologyStackSection from './TechnologyStackSection';
import PortfolioSection from './PortfolioSection';
import CorporateEngagementsSection from './CorporateEngagementsSection';
import PurposeValuesSection from './PurposeValuesSection';
import GetInTouchSection from './GetInTouchSection';
import FinalCTASection from './FinalCTASection';
import Footer from './Footer';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import AdminPanel from './AdminPanel';
import FloatingButtons from './FloatingButtons';
import SEO from './SEO';
import './App.css';

function HomePage() {
  return (
    <div className="App">
      <SEO 
        title="Garud Stacks - Enterprise Technology Solutions | AI & Cloud Services"
        description="Leading provider of enterprise technology solutions including AI, cloud computing, digital transformation, and custom software development for global businesses."
        image="https://garudstacks.tech/img/og-image.png"
        url="https://garudstacks.tech"
        keywords="enterprise technology, AI solutions, cloud computing, digital transformation, software development, web development, custom software"
      />
      <TopBar />
      <Navbar />
      <Hero />
      <ImpactSection />
      <WhatWeDoSection />
      <EcosystemSection />
      <TailoredSolutionsSection />
      <TechnologyStackSection />
      <PortfolioSection />
      <CorporateEngagementsSection />
      <PurposeValuesSection />
      <GetInTouchSection />
      <FinalCTASection />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <FloatingButtons />
    </>
  );
}

export default App;
